export default __webpack_public_path__ + "static/media/California Water Boards.3e348ec6.jpg";